module.exports = __webpack_public_path__ + "static/media/left_align_black.912f69df.svg";